// import { ReactNode } from "react";
// import { Navigate } from "react-router-dom";
// import { tokenService } from "@/services/auth/token.service";
// import { routes } from "@/app/navigation/routes";
// import { AuthenticatedLayout } from "./AuthenticatedLayout";

// interface AuthenticatedLayoutWrapperProps {
//   children?: ReactNode;
// }

// /**
//  * Wrapper that combines ProtectedRoute logic with AuthenticatedLayout
//  * Redirects to login if not authenticated, otherwise renders layout with children
//  */
// export const AuthenticatedLayoutWrapper = ({ children }: AuthenticatedLayoutWrapperProps = { children: undefined }) => {
//   const isAuthenticated = tokenService.hasToken();

//   if (!isAuthenticated) {
//     return <Navigate to={routes.login} replace />;
//   }

//   return <AuthenticatedLayout>{children}</AuthenticatedLayout>;
// };

import { Outlet, Navigate } from "react-router-dom";
import { AuthenticatedLayout } from "./AuthenticatedLayout";
import { tokenService } from "@/services/auth/token.service";
import { toastService } from "@/shared/toast";
import { routes } from "../navigation/routes";

export const AuthenticatedLayoutWrapper = () => {
  const isAuthenticated = tokenService.hasToken();

  if (!isAuthenticated) {
    toastService.show("Please sign in to continue.", "info");
    return <Navigate to={routes.login} replace />;
  }

  return (
    <AuthenticatedLayout>
      <Outlet />
    </AuthenticatedLayout>
  );
};
